export default {
	setQuiz(state, quiz) {
		state.quiz = quiz;
	},
	chooseAnswer(state, data) {
		if (data[2] == 1) {
			state.answer.filter((x) => (x.id == data[0] ? x.data = [data[1]] : ''));
		} else {
			state.answer.filter((x) => (x.id == data[0] && !x.data.includes(data[1]) ? x.data.push(data[1]) : ''));
		}
		state.answer.filter((x) => (x.id == data[0] ? x.num += 1 : ''));
		const get_num_answer = state.answer.find((x) => (x.id == data[0] ? x : ''));
		const get_num_correct = state.quiz.questions.find((q) => (q.id == data[0] ? q : ''));

		if (get_num_answer.num == get_num_correct.answers.length) {
			state.finish += 1;

			if (state.quiz.challengeId) {
				// questionId, kind, user_answer,playerId
				const isLastQuestion = state.finish == state.quiz.questions.length ? true : false;
				state.quiz.action('sendResponse', data[0], data[2], get_num_answer.data, state.quiz.playerId, isLastQuestion);
			}

			if (state.finish == state.quiz.questions.length) {
				state.quiz.playComplate();
			}
		}
	},
	nextQuestion(state) {
		state.num_question += 1;
	},
	backQuestion(state) {
		state.num_question -= 1;
	},
	setStartQuiz(state) {
		state.start_quiz = true;
	},
	updateTimePassed(state) {
		state.time_passed += 1;
	},
	doneQuestion(state) {
		state.done_click = true;
	}
};